// extracted by mini-css-extract-plugin
module.exports = {"header":"start-project_header__YH0Xm","title":"start-project_title__N4Tp3","content":"start-project_content__s3q4r"};